import './Loader.scss';
import { bem } from 'lib/bem';
import { Icon } from 'lib/ui/icon';

const { block } = bem('Loader');

export default function Loader(modifiers) {
  return <Icon glyph="rolling" {...block(modifiers)} width="100" height="100" />;
}
